module.exports = __webpack_public_path__ + "img/logo-headline65x400.0e3f4802.png";